<template>
	<select ref="el" class="form-control multiselect" :class="btnClass" multiple :data-non-selected-text="nonSelectedText">
		<option v-for="opt in options" :value="opt.value" :selected="isSelected(opt)">{{ opt.label }}</option>
	</select>
</template>

<script>
    import _ from 'lodash';
    import { uniqueId } from '../../utility/utils';

    export default {
        props: {
            options: {
                required: true
            },
            value: {
                default: () => []
            },
            nonSelectedText: {
                default: 'None selected'
            }
        },
        data() {
            return {
                model: [],
            }
        },
        computed: {
            btnClass() {
                return uniqueId('multi');
            }
        },
        methods: {
            initSelect(){
                let vm = this;
                try {
                    $(vm.$refs.el).multiselect('destroy');
                } catch (e) {}

                $(vm.$refs.el).multiselect({
                    enableFiltering: true,
                    includeSelectAllOption: true,
                    enableClickableOptGroups: true,
                    disableIfEmpty: false,
                    templates: {
                        filter: '<li class="multiselect-item multiselect-filter"><i class="icon-search4"></i> <input class="form-control" type="text"></li>'
                    },
                    inheritClass: true,
                    enableCaseInsensitiveFiltering: true,
                    onChange: function (option, checked) {
                        $.uniform.update();
                        $(vm.$refs.el).trigger('multiselectchange', {option, checked});
                    },
                    onSelectAll: function () {
                        $.uniform.update();
                        $(vm.$refs.el).trigger('multiselectselectall');
                    },
                    onDeselectAll: function () {
                        $(vm.$refs.el).trigger('multiselectdeselectall');
                    },
                    buttonWidth: '100%',
                });
			},
            /**
             * Add a selected option.
             *
             * @param value
             */
            addValue(value) {
                if (! _.isNil(this.model)) {
                    let index = _.findIndex(this.model, (m) => {
                        return m == value;
                    });

                    if (index < 0) {
                        this.model.push(value);
                    }
                }
            },

            /**
             * Determine if option is selected.
             *
             * @param opt
             */
            isSelected(opt) {
                return ! _.isNil(this.model) && this.model.includes(opt.value);
            },

            /**
             * Rebuild the control.
             */
            rebuild(options = []) {
                this.options = options;
                const vm = this;
                this.$nextTick(() => {
                    $(this.$refs.el).multiselect('rebuild')
                        .multiselect('select', this.model);

                    this.setText();
                });
            },

            /**
             * Set the button text.
             */
            setText() {
                Vue.nextTick(() => {
                    let text = '',
                        title = '';

                    this.model.forEach(model => {
                        if (text !== '') {
                            text += ', ';
                        }

                        if (title !== '') {
                            title += ', ';
                        }

                        let option = _.find(this.options, option => {
                            return option.value == model;
                        });

                        title += option ? option.label : 'Unknown';

                        if (this.model.length <= 2) {
                            text += option ? option.label : 'Unknown';
                        }
                    });

                    if (this.model.length <= 0) {
                        text = 'None Selected';
                    } else if (this.model.length === this.options.length) {
                        text = `All Selected (${this.options.length})`;
                    } else if (this.model.length > 2) {
                        text = `${this.model.length} Selected`;
                    }

                    $(`button.${this.btnClass}`).attr('title', title);
                    $(`button.${this.btnClass} > span`).html(text);
                });
            },

            /**
             * Remove an option.
             *
             * @param value
             */
            removeValue(value) {
                this.model = _.filter(this.model, (m) => {
                    return m != value;
                });
            }
        },
        mounted() {
            this.model = this.value;

            $(document).on('multiselectchange', (e, data) => {
                if (data.option) {
                    let value = $(data.option).val();

                    if (! _.isNil(data.checked) && data.checked === true) {
                        this.addValue(value);
                    } else {
                        this.removeValue(value);
                    }
                }
            });

            $(document).on('multiselectselectall', () => {
                let selectedOptions = $(this.$refs.el).find('option:selected').length;
                this.model = [];

                if (selectedOptions > 0) {
                    this.options.forEach(opt => {
                        this.model.push(opt.value);
                    });
                }
            });
        },
        watch: {
            model: function(model) {
                this.$emit('input', model);
                this.setText();
            },
            value(value) {
                this.model = value;
            }
        }
    }
</script>